import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b546a14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-list-netflix" }
const _hoisted_2 = {
  class: "container",
  href: "https://clinicarx.com.br/blog/vai-ficar-de-quarentena-em-casa-confira-nossa-lista-de-filmes-e-series/"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-text" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Filmes para assistir na quarentena"),
  /*#__PURE__*/_createElementVNode("h4", null, "Lista de Clinicarx na Netflix"),
  /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", { src: _ctx.netflixIconPath }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}